var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "reverse-on-small", attrs: { wrap: "" } },
    [
      !_vm.hideForm
        ? _c(
            "v-flex",
            {
              class: { "block-form-container": !_vm.signedIn },
              attrs: { xl4: _vm.selectedBid, md6: "" }
            },
            [
              _vm.hasBids && !_vm.bid
                ? _c(
                    "v-layout",
                    [
                      _c("v-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          items: _vm.bids,
                          label: "Your bids",
                          "persistent-hint": "",
                          "error-messages": _vm.errors.first("bid"),
                          "data-vv-as": "Bid",
                          "data-vv-name": "bid",
                          "item-text": _vm.bidFormat,
                          "item-value": "bidId"
                        },
                        model: {
                          value: _vm.selectedBid,
                          callback: function($$v) {
                            _vm.selectedBid = $$v
                          },
                          expression: "selectedBid"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideForm
                ? _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { md12: "" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              items: _vm.filteredTruckingCompanies,
                              label: "Bidding Company",
                              "item-text": "companyName",
                              "item-value": "id",
                              "error-messages": _vm.errors.first("company"),
                              "data-vv-as": "Company Name",
                              "data-vv-name": "company",
                              disabled: _vm.disableForm || _vm.hasBids
                            },
                            model: {
                              value: _vm.bidForm.truckingCompanyId,
                              callback: function($$v) {
                                _vm.$set(_vm.bidForm, "truckingCompanyId", $$v)
                              },
                              expression: "bidForm.truckingCompanyId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md12: "" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              items: _vm.loadsOptions,
                              label: "Number of Loads",
                              disabled: _vm.disableForm,
                              "error-messages": _vm.errors.first("loads"),
                              "data-vv-as": "Number of Loads",
                              "data-vv-name": "loads",
                              "item-text": "text",
                              "item-value": "value"
                            },
                            model: {
                              value: _vm.bidForm.numberOfLoads,
                              callback: function($$v) {
                                _vm.$set(_vm.bidForm, "numberOfLoads", $$v)
                              },
                              expression: "bidForm.numberOfLoads"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md12: "" } },
                        [
                          _vm.ifLoadboardBiddingEnabled
                            ? _c("v-float-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min_value:1",
                                    expression: "'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label: "Enter your per load rate ($)",
                                  disabled: _vm.disableForm,
                                  "error-messages": _vm.errors.first(
                                    "bidFormRate"
                                  ),
                                  "data-vv-as": "Load rate",
                                  "data-vv-name": "bidFormRate",
                                  messages: _vm.perDistanceCostMessage
                                },
                                model: {
                                  value: _vm.bidForm.bidAmount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.bidForm, "bidAmount", $$v)
                                  },
                                  expression: "bidForm.bidAmount"
                                }
                              })
                            : _c("v-text-field", {
                                attrs: {
                                  disabled: "",
                                  value: _vm.fixedRateLoadAmount,
                                  label: "per load rate ($)"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._.get(_vm.listing, "bids.placed") > 0
                        ? _c(
                            "v-flex",
                            {
                              staticClass: "pt-1",
                              attrs: { md12: "", justified: "" }
                            },
                            [
                              _c("span", { staticClass: "font-italic mt-5" }, [
                                _vm._v(
                                  "(Lowest bid: $" +
                                    _vm._s(_vm.listing.bids.minimumBid) +
                                    ")"
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md12: "" } },
                        [
                          _c("date-picker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "bidPickup",
                            attrs: {
                              "input-id": "pickupTimePicker",
                              placeholder: "Pickup Date",
                              "data-vv-as": "Pickup Date",
                              "data-vv-name": "pickupTimePicker",
                              disabled: _vm.disableForm
                            },
                            model: {
                              value: _vm.bidForm.pickupTime,
                              callback: function($$v) {
                                _vm.$set(_vm.bidForm, "pickupTime", $$v)
                              },
                              expression: "bidForm.pickupTime"
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.first("pickupTimePicker")
                            ? _c(
                                "div",
                                { staticClass: "v-text-field__details pt-1" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "v-messages error--text" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "v-messages__wrapper" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "v-messages__message"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "pickupTimePicker"
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideForm
                ? _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        [
                          !_vm.hasBids
                            ? _c("v-textarea", {
                                attrs: {
                                  disabled: _vm.disableForm,
                                  label: "Questions (optional)",
                                  clearable: "",
                                  color: "secondary"
                                },
                                model: {
                                  value: _vm.bidForm.message,
                                  callback: function($$v) {
                                    _vm.$set(_vm.bidForm, "message", $$v)
                                  },
                                  expression: "bidForm.message"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            {
                              staticClass: "pb-3",
                              attrs: { "justify-end": "" }
                            },
                            [
                              !_vm.hasBids && !_vm.isDisabled
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "accent mr-0",
                                      attrs: {
                                        disabled:
                                          _vm.disableForm || _vm.errors.any(),
                                        loading: _vm.placeBidLoading
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.placeBid()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "pl-2",
                                          attrs: { color: "white" }
                                        },
                                        [_vm._v("gavel")]
                                      ),
                                      _vm._v(
                                        "\n            Submit Bid\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isDisabled
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "accent mr-0",
                                      attrs: { disabled: true }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "pl-2",
                                          attrs: { color: "white" }
                                        },
                                        [_vm._v("gavel")]
                                      ),
                                      _vm._v(
                                        "\n            Account Disabled\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasBids && !_vm.isAccepted
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "accent mr-0",
                                      attrs: { loading: _vm.placeBidLoading },
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelBid()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "pl-2",
                                          attrs: { color: "white" }
                                        },
                                        [_vm._v("cancel")]
                                      ),
                                      _vm._v(" "),
                                      _vm.isLoadboardBiddingEnabled
                                        ? _c("span", [_vm._v("Cancel Bid")])
                                        : _c("span", [
                                            _vm._v("Revoke Availability")
                                          ])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasBids && _vm.isLoadboardBiddingEnabled
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "accent mr-0",
                                      attrs: {
                                        disabled:
                                          _vm.disableForm || _vm.errors.any(),
                                        loading: _vm.placeBidLoading
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.updateBid()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "pl-2",
                                          attrs: { color: "white" }
                                        },
                                        [_vm._v("gavel")]
                                      ),
                                      _vm._v(
                                        "\n            Update Bid\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasBids && _vm.isAccepted
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-0",
                                      attrs: {
                                        flat: "",
                                        to:
                                          "/companies/" +
                                          _vm.bidForm.truckingCompanyId +
                                          "/booked-loads"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Booked Loads\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.signedIn
                ? _c(
                    "div",
                    { staticClass: "block-form-overlay" },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            column: "",
                            "justify-center": "",
                            "align-center": "",
                            "fill-height": ""
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "accent",
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({ name: "onboard" })
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          Register now to start bidding instantly!\n        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$vuetify.breakpoint.xl && _vm.selectedBid
        ? _c(
            "v-flex",
            {
              staticClass: "mb-2 px-2 text-xs-center",
              attrs: { lg4: "", "justify-center": "" }
            },
            [
              _vm.selectedBid
                ? _c("bid-conversation", {
                    attrs: {
                      "disable-form": _vm.disableForm,
                      "bid-id": _vm.selectedBid
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.hideMapAndConversation
        ? _c(
            "v-flex",
            {
              staticClass: "mb-2 px-2 text-xs-center",
              attrs: {
                xs12: "",
                md6:
                  !_vm.hideForm &&
                  (_vm.$vuetify.breakpoint.lgAndDown || !_vm.selectedBid),
                lg4:
                  !_vm.hideForm &&
                  _vm.$vuetify.breakpoint.xl &&
                  _vm.selectedBid,
                "justify-center": ""
              }
            },
            [
              _vm.selectedBid && _vm.$vuetify.breakpoint.lgAndDown
                ? _c(
                    "v-btn-toggle",
                    {
                      staticClass: "day-night-toggle mb-2",
                      attrs: { mandatory: "" },
                      model: {
                        value: _vm.viewToggle,
                        callback: function($$v) {
                          _vm.viewToggle = $$v
                        },
                        expression: "viewToggle"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        { attrs: { flat: "", value: "map" } },
                        [
                          _c("span", [_vm._v("Map")]),
                          _vm._v(" "),
                          _c("v-icon", [_vm._v("map")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { flat: "", value: "timeline" } },
                        [
                          _c("span", [_vm._v("Conversation")]),
                          _vm._v(" "),
                          _c("v-icon", [_vm._v("chat")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("load-map", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.viewToggle === "map",
                    expression: "viewToggle === 'map'"
                  }
                ],
                attrs: {
                  "disable-zoom": !_vm.signedIn,
                  "origin-place-id": _vm.originPlaceId,
                  "destination-place-id": _vm.destinationPlaceId
                }
              }),
              _vm._v(" "),
              _vm.selectedBid
                ? _c("bid-conversation", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewToggle === "timeline",
                        expression: "viewToggle === 'timeline'"
                      }
                    ],
                    attrs: {
                      "disable-form": _vm.disableForm,
                      "bid-id": _vm.selectedBid
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b4a5e3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b4a5e3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BidForm.vue
// module id = null
// module chunks = 